import { Autocomplete, FormControl, TextField } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { addScroll, removeScroll } from 'src/utils/commonMethods'

export const AutoCompleteInput = ({
  optionList,
  handleChange,
  handleOptionLabel,
  value,
  label,
  nameLabel,
}) => {
  const classes = useStyles()
  return (
    <div>
      <FormControl>
        <Autocomplete
          id='autoComplete'
          size='small'
          className={classes.selectWidth}
          options={optionList}
          getOptionLabel={handleOptionLabel} // Specify the label for each option
          value={value} // The selected value
          onChange={(event, newValue) =>
            handleChange(event, newValue, nameLabel)
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              name={nameLabel}
              InputLabelProps={{
                shrink: true,
              }}
              variant='outlined'
              inputProps={{
                ...params.inputProps,
                autoComplete: 'new-password', // Disable browser's autocomplete
                className: classes.autoStyle,
              }}
            />
          )}
          onOpen={() => {
            removeScroll()
          }}
          onClose={() => {
            addScroll()
          }}
        />
      </FormControl>
    </div>
  )
}

const useStyles = makeStyles({
  selectWidth: {
    minWidth: 140,
    fontSize: '11px !important',
  },

  inputWidth: {
    width: 140,
    fontSize: '12px !important',
  },
  arrowButton: {
    marginTop: 4,
  },
  autoStyle: {
    fontSize: '12px !important',
    height: '8px !important',
    color: 'black',
  },
})
